import React, { useEffect, useState } from "react";

// import your 32 teeth images
import t1 from "../../../Assets/Images/teeth1.png";
import t2 from "../../../Assets/Images/teeth2.png";
import t3 from "../../../Assets/Images/teeth3.png";
import t4 from "../../../Assets/Images/teeth4.png";
import t5 from "../../../Assets/Images/teeth5.png";
import t6 from "../../../Assets/Images/teeth6.png";
import t7 from "../../../Assets/Images/teeth7.png";
import t8 from "../../../Assets/Images/teeth8.png";
import t9 from "../../../Assets/Images/teeth9.png";
import t10 from "../../../Assets/Images/teeth10.png";
import t11 from "../../../Assets/Images/teeth11.png";
import t12 from "../../../Assets/Images/teeth12.png";
import t13 from "../../../Assets/Images/teeth13.png";
import t14 from "../../../Assets/Images/teeth14.png";
import t15 from "../../../Assets/Images/teeth15.png";
import t16 from "../../../Assets/Images/teeth16.png";
import t17 from "../../../Assets/Images/teeth17.png";
import t18 from "../../../Assets/Images/teeth18.png";
import t19 from "../../../Assets/Images/teeth19.png";
import t20 from "../../../Assets/Images/teeth20.png";
import t21 from "../../../Assets/Images/teeth21.png";
import t22 from "../../../Assets/Images/teeth22.png";
import t23 from "../../../Assets/Images/teeth23.png";
import t24 from "../../../Assets/Images/teeth24.png";
import t25 from "../../../Assets/Images/teeth25.png";
import t26 from "../../../Assets/Images/teeth26.png";
import t27 from "../../../Assets/Images/teeth27.png";
import t28 from "../../../Assets/Images/teeth28.png";
import t29 from "../../../Assets/Images/teeth29.png";
import t30 from "../../../Assets/Images/teeth30.png";
import t31 from "../../../Assets/Images/teeth31.png";
import t32 from "../../../Assets/Images/teeth32.png";

const upperTeeth = [
  t1,
  t2,
  t3,
  t4,
  t5,
  t6,
  t7,
  t8,
  t9,
  t10,
  t11,
  t12,
  t13,
  t14,
  t15,
  t16,
];

const lowerTeeth = [
  t17,
  t18,
  t19,
  t20,
  t21,
  t22,
  t23,
  t24,
  t25,
  t26,
  t27,
  t28,
  t29,
  t30,
  t31,
  t32,
];

export default function Odontogram({ values, setValues, editTrue }) {
  //   const [values, setValues] = useState(Array(32).fill(""));



  const handleChange = (index, value) => {
    setValues((prev) => {
      const updated = [...prev];
      updated[index] = value;
      return updated;
    });
  };

  // Components
  function SectionTitle({ title }) {
    return (
      <div className="text-center font-semibold mb-0.5 text-xs">
        {title}
      </div>
    );
  }

  function SectionLabels() {
    const sections = [
      { name: "MOLARS", span: 3 },
      { name: "PREMOLARS", span: 2 },
      { name: "CANINE", span: 1 },
      { name: "INCISORS", span: 4 },
      { name: "CANINE", span: 1 },
      { name: "PREMOLARS", span: 2 },
      { name: "MOLARS", span: 3 },
    ];

    return (
      <div className="grid grid-cols-16 gap-1 mb-2 text-[8px] text-center">
        {sections.map((sec, i) => (
          <div
            key={i}
            className="border-b border-gray-400/20 text-gray-400/60 pb-1"
            style={{ gridColumn: `span ${sec.span}` }}
          >
            {sec.name}
          </div>
        ))}
      </div>
    );
  }

  //   function InputsRow({ startIndex, values, onChange }) {
  //     return (
  //       <div className="grid grid-cols-16 gap-3 mb-3">
  //         {Array.from({ length: 16 }).map((_, i) => (
  //           <input
  //             key={i}
  //             value={values?.[startIndex + i] || ""}
  //             onChange={(e) =>
  //               onChange(startIndex + i, e.target.value)
  //             }
  //             className="
  //             w-full
  //             h-12
  //             rounded-lg
  //             bg-gray-200
  //             text-black
  //             text-center
  //             font-semibold
  //             text-sm
  //             outline-none
  //           "
  //           />
  //         ))}
  //       </div>
  //     );
  //   }

  function ToothNumbers({ start }) {
    return (
      <div className="grid grid-cols-16 gap-1 text-center text-[8px] text-gray-300 mb-1.5">
        {Array.from({ length: 16 }).map((_, i) => (
          <div key={i}>{start + i}</div>
        ))}
      </div>
    );
  }

  function TeethRow({ images, reverse = false }) {
    return (
      <div className="grid grid-cols-16 gap-1 mb-2 items-center">
        {(reverse ? [...images].reverse() : images).map((imageSrc, i) => (
          <div key={i} className="flex justify-center">
            <img src={imageSrc} alt="" className="h-7 object-contain" />
          </div>
        ))}
      </div>
    );
  }

  function Legend() {
    return (
      <div className="mt-0.5 mb-0.5 border-t border-gray-600 pt-2 text-xs text-gray-100">
        <div className="mb-4 font-medium">Legend:</div>

        <div className="flex flex-wrap gap-4">
          <span>C - Dental Caries</span>
          <span>CO - Composite Filling</span>
          <span>RF - Root Fragment</span>
          <span>Un - Un-erupted</span>
          <span>P - Pontic</span>
          <span>Am - Amalgam Filling</span>
          <span>X - Tooth for Extraction</span>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-2  text-white bg-[#140a5c] ">
      {/* TITLE */}
      {/* <div className="text-center py-8">
        <h1 className="text-3xl font-semibold tracking-wide">Odontogram</h1>
      </div> */}

      <div className="max-w-4xl mx-auto px-2">
        {/* UPPER JAW */}
        <SectionTitle title="UPPER JAW" />

        <SectionLabels />

        {/* Upper Inputs */}
        <div className="grid grid-cols-16 gap-1 mb-0.5">
          {Array.from({ length: 16 }).map((_, i) => (
            <input
              disabled={editTrue}
              key={0 + i}
              value={values?.[0 + i] || ""}
              onChange={(e) => handleChange(0 + i, e.target.value)}
              className="
            w-full
            h-10
            rounded-lg
            bg-gray-200
            text-black
            text-center
            font-semibold
            text-sm
            outline-none
          "            />
          ))}
        </div>

        {/* Tooth Numbers */}
        <ToothNumbers start={1} />

        {/* Upper Teeth Images */}
        <TeethRow images={upperTeeth} />

        {/* Lower Teeth Images */}
        <TeethRow images={lowerTeeth} reverse />

        {/* Tooth Numbers */}
        <ToothNumbers start={17} />

        {/* Lower Inputs */}
        {/* <InputsRow
          startIndex={16}
          values={values}
          onChange={handleChange}
        /> */}
        <div className="grid grid-cols-16 gap-1 mb-1.5">
          {Array.from({ length: 16 }).map((_, i) => (
            <input
              disabled={editTrue}
              key={16 + i}
              value={values?.[16 + i] || ""}
              onChange={(e) => handleChange(16 + i, e.target.value)}
              className="
            w-full
            h-10
            rounded-lg
            bg-gray-200
            text-black
            text-center
            font-semibold
            text-sm
            outline-none
          "            />
          ))}
        </div>

        <SectionLabels />

        {/* LOWER JAW */}
        <SectionTitle title="LOWER JAW" />

        {!editTrue && <Legend />}
      </div>
    </div>
  );
}
